const CHAIN_SWITCHED = '/chain-switched';
const SETTINGS = '/app/settings';
const SETTINGS_CONNECTIVITY = '/app/settings/connectivity';
const HOME = '/app/home';
const DEFAULT = HOME;

const PATHS = {
  DEFAULT,
  CHAIN_SWITCHED,
  SETTINGS,
  SETTINGS_CONNECTIVITY,
  HOME,
};

export default PATHS;
